export default "__VITE_ASSET__BMy_wQZy__"